import { render } from "./MensagemAlerta.vue?vue&type=template&id=1a8416f8&scoped=true"
import script from "./MensagemAlerta.vue?vue&type=script&lang=js"
export * from "./MensagemAlerta.vue?vue&type=script&lang=js"

import "./MensagemAlerta.vue?vue&type=style&index=0&id=1a8416f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8416f8"]])

export default __exports__